import {
  type INode,
  LayoutExecutor,
  type Rect,
  type IAnimation,
  ViewportAnimation,
} from '@ardoq/yfiles';

/** A {@link LayoutExecutor} that modifies the viewport animation to zoom to a list of nodes. */
class ZoomToNodesLayoutExecutor extends LayoutExecutor {
  constructor(
    private nodes: INode[],
    ...options: ConstructorParameters<typeof LayoutExecutor>
  ) {
    super(...options);
  }

  override createViewportAnimation(targetBounds: Rect): IAnimation {
    if (this.nodes.length === 0) {
      return super.createViewportAnimation(targetBounds);
    }

    const layoutNodes = this.nodes.map(node =>
      this.adapter!.getLayoutNode(node)!
    );
    const bounds = this.adapter!.layoutGraph.getBounds(layoutNodes);

    const viewportAnimation = new ViewportAnimation(
      this.graphComponent,
      bounds,
      this.animationDuration
    );
    viewportAnimation.targetMargins = 20;
    viewportAnimation.maximumTargetZoom = 1;
    return viewportAnimation;
  }
}
export { ZoomToNodesLayoutExecutor };
